import { registerLocaleData } from "@angular/common";
import localePl from "@angular/common/locales/pl";
import localePlExtra from "@angular/common/locales/extra/pl";
registerLocaleData(localePl, "pl", localePlExtra);
const ɵ0 = window.navigator.language;
export class AppModule {
}
export { ɵ0 };
